// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './users-api';

export const useListUsers: typeof hookExports.useListUsers = hookExports.useListUsers;
export const useLazyListUsers: typeof hookExports.useLazyListUsers = hookExports.useLazyListUsers;
export const useGetUser: typeof hookExports.useGetUser = hookExports.useGetUser;
export const useLazyGetUser: typeof hookExports.useLazyGetUser = hookExports.useLazyGetUser;
export const useListUserStatuses: typeof hookExports.useListUserStatuses =
  hookExports.useListUserStatuses;
export const useLazyListUserStatuses: typeof hookExports.useLazyListUserStatuses =
  hookExports.useLazyListUserStatuses;
export const useUpdateUser: typeof hookExports.useUpdateUser = hookExports.useUpdateUser;
export const useBlockUser: typeof hookExports.useBlockUser = hookExports.useBlockUser;
export const useUnblockUser: typeof hookExports.useUnblockUser = hookExports.useUnblockUser;
export const useResetUserMfa: typeof hookExports.useResetUserMfa = hookExports.useResetUserMfa;
export const useSetUserRoles: typeof hookExports.useSetUserRoles = hookExports.useSetUserRoles;
export const useConfirmEmail: typeof hookExports.useConfirmEmail = hookExports.useConfirmEmail;
